import { defineComponent } from 'vue';
export default defineComponent({
    name: 'BlockedStatus',
    props: {},
    components: {},
});
